import * as React from "react";
import type { SVGProps } from "react";
const SvgPointer02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m12.296 18.145 6.148 2.989c1.152.56 2.382-.612 1.877-1.79L13.525 3.488c-.472-1.104-2.03-1.123-2.53-.032L3.694 19.387c-.533 1.164.665 2.366 1.83 1.836z"
    />
  </svg>
);
export default SvgPointer02;
